import { render, staticRenderFns } from "./NotificacionCard.vue?vue&type=template&id=05dfc5ea&scoped=true&"
import script from "./NotificacionCard.vue?vue&type=script&lang=js&"
export * from "./NotificacionCard.vue?vue&type=script&lang=js&"
import style0 from "./NotificacionCard.vue?vue&type=style&index=0&id=05dfc5ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dfc5ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
